import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useLayoutsButtonStyles = makeStyles(({ spacing }) => {
  return createStyles({
    layoutIconWrapper: {
      height: '190px',
      width: '230px',
      cursor: 'pointer',
    },
    gridLayoutsContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      marginTop: spacing(4),
    },
    containerClassName: {
      maxWidth: '500px',
      width: '100%',
    },
    container: {
      overflow: 'hidden',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
      gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
      gap: '2px',
      gridAutoFlow: 'row',
      gridTemplateAreas: `". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."
          ". . . . . . . . . . . ."`,
      height: '100%',
      width: '100%',
      border: 'none',
      backgroundColor: 'transparent',
    },
  });
});

export default useLayoutsButtonStyles;
